import type { FormFieldType, FormResponseValueAnswer } from "@tellescope/types-models";

const STRING_VALUED_TYPES: FormFieldType[] = ["string", "stringLong", "dateString", "email", "phone", "Stripe"];
const NUMBER_VALUED_TYPES: FormFieldType[] = ["number", "rating"];
const CHOICE_TYPES: FormFieldType[] = ["multiple_choice", "Dropdown"];

/**
 * Whether a stored answer can safely hydrate a field of `fieldType`.
 *
 * A form's fields can be retyped after a response was saved, which would otherwise load a value the
 * new widget cannot render. An answer survives when its own type matches, or when its value shape is
 * one the target type also accepts (a string into any string-valued type, a number into `number` or
 * `rating`, a string array into a choice type); anything else is dropped rather than hydrated.
 */
export const isAnswerCompatibleWithField = (answer: FormResponseValueAnswer, fieldType: FormFieldType): boolean => {
  if (answer.type === fieldType) return true;

  const { value } = answer;
  if (typeof value === "string") return STRING_VALUED_TYPES.includes(fieldType) || CHOICE_TYPES.includes(fieldType);
  if (typeof value === "number") return NUMBER_VALUED_TYPES.includes(fieldType);
  if (Array.isArray(value)) return CHOICE_TYPES.includes(fieldType);

  return false;
};
